import React, { useState, useEffect } from 'react';
import ModalAtividade from '../../ProspectoDetalhes/ModalAtividades';
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import FormularioVisita from '~/Components/FormularioVisita';
import FormularioTarefas from '~/Components/FormularioTarefas';
import { TIPO_ATIVIDADE, STATUS_CODE_OK } from '~/constant';
import moment from 'moment';
import '../agenda.css';
import { Button, Card, CloseButton, Modal } from 'react-bootstrap';

export default function CalendarioAgenda({
  atividades,
  setAtividades,
  dataSelecionada,
  changeDataSelecionada,
}) {
  const [popupData, setPopupData] = useState(null);
  const [salvandoDados, setSalvandoDados] = useState();
  const [modalCadastro, setModalCadastro] = useState(false);
  const [modoMobile, setModoMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    function handleResize() {
      setModoMobile(window.innerWidth <= 768);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const diasSemana = modoMobile
    ? ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
    : ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

  const fecharModais = () => {
    setPopupData(null);
  };

  const atividadeEtapaStringToEnum = situacao => {
    switch (situacao) {
      case 'Pendente':
        return 1;
      case 'Concluído':
        return 2;
      case 'Em Andamento':
        return 3;
      case 'Cancelado':
        return 4;
      case 'Vencido':
        return 5;
      default:
        return 1;
    }
  };

  const reconstruirAtividades = response => {
    if (!response || !response.nova_atividade) return;
    setAtividades(prevAtividades =>
      prevAtividades.map(item =>
        item.codigo_atividade === response.nova_atividade.codigo_atividade
          ? response.nova_atividade
          : item
      )
    );
  };

  const editarModalFormulario = async (dados, tipoAtividade) => {
    var request = {
      tipo_atividade: tipoAtividade,
      atividade_etapa: atividadeEtapaStringToEnum(dados.situacao),
      descricao_atividade: JSON.stringify(dados),
      codigo_atividade: dados.codigoAtividade,
      data_conclusao: dados.data,
      codigo_responsavel: dados.responsavel.split('-')[0].trim(),
    };
    editarFormulario(request);
  };

  const editarFormulario = async dados => {
    try {
      var request = {
        ...dados,
      };
      let response = await api.editarAtividade(request);
      if (response.status === STATUS_CODE_OK) {
        fecharModais();
        toast.success(`Atividade editada com sucesso.`);
        reconstruirAtividades(response);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const gerarDiasDoMes = () => {
    const dataAtual = moment(dataSelecionada);
    const primeiroDiaDoMes = dataAtual.clone().startOf('month');
    const ultimoDiaDoMes = dataAtual.clone().endOf('month');

    const diaSemanaInicio = primeiroDiaDoMes.day();

    const diasAnteriores = [];
    if (diaSemanaInicio > 0) {
      const mesAnterior = primeiroDiaDoMes.clone().subtract(1, 'month');
      const ultimoDiaMesAnterior = mesAnterior.daysInMonth();
      for (let i = diaSemanaInicio - 1; i >= 0; i--) {
        diasAnteriores.push({
          dia: ultimoDiaMesAnterior - i,
          mesAtual: false,
          data: mesAnterior.clone().date(ultimoDiaMesAnterior - i),
        });
      }
    }

    const diasDoMes = [];
    for (let i = 1; i <= ultimoDiaDoMes.date(); i++) {
      diasDoMes.push({
        dia: i,
        mesAtual: true,
        data: primeiroDiaDoMes.clone().date(i),
      });
    }

    const totalDias = diasAnteriores.length + diasDoMes.length;
    const diasRestantes = totalDias % 7 === 0 ? 0 : 7 - (totalDias % 7);
    const diasPosteriores = [];
    const proximoMes = ultimoDiaDoMes.clone().add(1, 'day');
    for (let i = 1; i <= diasRestantes; i++) {
      diasPosteriores.push({
        dia: i,
        mesAtual: false,
        data: proximoMes.clone().date(i),
      });
    }

    return [...diasAnteriores, ...diasDoMes, ...diasPosteriores];
  };

  const getAtividadesDoDia = (data) => {
    if (!atividades || !Array.isArray(atividades)) return [];
    return atividades.filter(a =>
      moment(a.data_conclusao).format('YYYY-MM-DD') === data.format('YYYY-MM-DD')
    );
  };

  const handleClickDia = (data, atividadesDoDia) => {
    changeDataSelecionada(data.toDate());
  };

  const handleClickAtividade = (atividade, e) => {
    e.stopPropagation();
    setPopupData({ schedule: { raw: atividade } });
  };

  const isHoje = (data) => {
    return data.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');
  };

  const isSelecionado = (data) => {
    return data.format('YYYY-MM-DD') === moment(dataSelecionada).format('YYYY-MM-DD');
  };

  const dias = gerarDiasDoMes();
  const maxAtividadesVisiveis = modoMobile ? 1 : 2;

  return (
    <>
      <Card style={{ border: 'none', boxShadow: 'none' }}>
        <Card.Body className="p-0">
          <div className="calendario-custom">
            <div className="calendario-header">
              {diasSemana.map((dia, index) => (
                <div
                  key={index}
                  className="calendario-header-dia"
                  style={{ color: index === 0 ? '#e74c3c' : '#333' }}
                >
                  {dia}
                </div>
              ))}
            </div>

            <div className="calendario-grid">
              {dias.map((diaObj, index) => {
                const atividadesDoDia = getAtividadesDoDia(diaObj.data);
                const temMaisAtividades = atividadesDoDia.length > maxAtividadesVisiveis;
                const atividadesVisiveis = atividadesDoDia.slice(0, maxAtividadesVisiveis);
                const atividadesRestantes = atividadesDoDia.length - maxAtividadesVisiveis;

                return (
                  <div
                    key={index}
                    className={`calendario-dia ${!diaObj.mesAtual ? 'outro-mes' : ''} ${isSelecionado(diaObj.data) ? 'selecionado' : ''} ${isHoje(diaObj.data) ? 'hoje' : ''}`}
                    onClick={() => handleClickDia(diaObj.data, atividadesDoDia)}
                  >
                    <div className="calendario-dia-header">
                      <div
                        className="calendario-dia-numero"
                        style={{
                          color: !diaObj.mesAtual ? '#ccc' : (index % 7 === 0 ? '#e74c3c' : '#333')
                        }}
                      >
                        {diaObj.dia}
                      </div>
                      {temMaisAtividades && (
                        <div className="calendario-mais">
                          +{atividadesRestantes}
                        </div>
                      )}
                    </div>

                    <div className="calendario-atividades">
                      {atividadesVisiveis.map((atividade, idx) => (
                        <div
                          key={idx}
                          className={`calendario-atividade ${atividade.descricao_tipo_atividade === 'Tarefa' ? 'tarefa' : 'visita'}`}
                          onClick={(e) => handleClickAtividade(atividade, e)}
                          title={JSON.parse(atividade.atividade).descricao}
                        >
                          {atividade.descricao_tipo_atividade}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Card.Body>

        {popupData &&
          (() => {
            switch (popupData.schedule.raw.tipo_atividade) {
              case TIPO_ATIVIDADE.TAREFA:
                return (
                  <ModalAtividade
                    show={!!popupData}
                    onHide={() => {
                      setPopupData(null);
                    }}
                    titulo="Editar Atividade - Tarefa"
                    salvando={salvandoDados}
                    codigo_prospecto={popupData.schedule.raw.codigo_prospecto}
                    componente={
                      <FormularioTarefas
                        onSubmit={values =>
                          editarModalFormulario(
                            values,
                            TIPO_ATIVIDADE.TAREFA,
                            true
                          )
                        }
                        initialValues={{
                          ...JSON.parse(popupData.schedule.raw.atividade),
                          codigoAtividade:
                            popupData.schedule.raw.codigo_atividade,
                        }}
                        modoEdicao={true}
                        readOnly={true}
                        closeModal={() => {
                          setPopupData(null);
                        }}
                      />
                    }
                  />
                );
              case TIPO_ATIVIDADE.VISITA:
                return (
                  <ModalAtividade
                    show={!!popupData}
                    onHide={() => {
                      setPopupData(null);
                    }}
                    titulo="Editar Atividade - Visita"
                    salvando={salvandoDados}
                    codigo_prospecto={popupData.schedule.raw.codigo_prospecto}
                    componente={
                      <FormularioVisita
                        onSubmit={values =>
                          editarModalFormulario(
                            values,
                            TIPO_ATIVIDADE.VISITA,
                            true
                          )
                        }
                        initialValues={{
                          ...JSON.parse(popupData.schedule.raw.atividade),
                          codigoAtividade:
                            popupData.schedule.raw.codigo_atividade,
                        }}
                        modoEdicao={true}
                        readOnly={true}
                        closeModal={() => {
                          setPopupData(null);
                        }}
                      />
                    }
                  />
                );
              default:
                return null;
            }
          })()}
      </Card>

      {modalCadastro && (
        <Modal
          show={modalCadastro}
          onHide={() => {
            setModalCadastro(false);
          }}
          centered
        >
          <Modal.Body
            style={{ padding: '0 !important', margin: '0 !important' }}
          >
            <div
              className="centered-empty-state"
              style={{ position: 'relative' }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '12px',
                  right: '12px',
                  zIndex: 10,
                }}
              >
                <CloseButton
                  onClick={() => {
                    setModalCadastro(false);
                  }}
                ></CloseButton>
              </div>
              <div className="empty-state-card" style={{ border: 'none' }}>
                <div className="titulo-empty-state-agenda">
                  Não existe tarefa para este dia
                </div>
                <div
                  style={{
                    color: '#b0b0b0',
                    fontSize: 15,
                    margin: 24,
                  }}
                >
                  Novas tarefas devem ser criadas
                  <br />a partir de um lead.
                </div>
                <Button
                  className="btn-gestao-leads"
                  variant="teal"
                  onClick={() => (window.location.href = '/prospectos')}
                >
                  Ir para gestão de leads
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
